import { Hidden, List } from "@origin-digital/ods-core";
import styled from "styled-components";

export const AIAnswerCard = styled.div`
  padding: 1px;
  margin-bottom: 4.5rem;
`;

export const BottomAlignedBox = styled(Hidden)`
  margin-top: auto;
`;

export const SkeletonCard = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: calc(1rem - 1px);
`;

export const PillsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

// Status sets background via styled-components class — override to transparent
export const SourceChipLink = styled.a`
  text-decoration: none;
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.palette.borderColor.primary};
  border-radius: 8px;
  overflow: hidden;

  & > span {
    background-color: transparent !important;
  }

  &:hover > span {
    background-color: ${({ theme }) =>
      theme.palette.backgroundColor.grey} !important;
  }
`;

export const ThumbBtn = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

// Block rhythm for the markdown answer. react-markdown emits a flat run of
// sibling blocks (paragraphs, lists, headings) rather than a structure ODS
// Stack can space, so the gap is applied here instead. Spacing only — every
// block's own typography comes from the ODS component it maps to.
export const MarkdownBlocks = styled.div`
  > * + * {
    margin-top: 0.75rem;
  }

  // Nested lists lose the top gap: the parent list item already spaces them.
  li > ul,
  li > ol {
    margin-top: 0.25rem;
  }
`;

// ODS List draws its numbers with a CSS counter rather than the browser's own
// list marker — it sets `list-style: none` and renders the digit through
// generated content — so a markdown `3.` start is silently ignored and every
// ordered list restarts at 1. Seeding the counter with `start - 1` honours it
// without giving up ODS typography.
//
// ODS scopes its own `counter-reset: listCounter` under `&&&`, so this needs
// one level more specificity to win.
export const MarkdownOrderedList = styled(List)<{ $start: number }>`
  &&&& {
    counter-reset: listCounter ${({ $start }) => $start - 1};
  }
`;
